// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface TrashItem
 */
export interface TrashItem {
  /**
   * Trash entry ID. Use this ID when restoring the item.
   * @type {number}
   * @memberof TrashItem
   */
  id: number;
  /**
   * Project that owns this Trash entry.
   * @type {number}
   * @memberof TrashItem
   */
  project: number;
  /**
   *
   * @type {string}
   * @memberof TrashItem
   */
  itemType: TrashItemItemTypeEnum;
  /**
   * Original test case or suite ID, preserved on restore.
   * @type {number}
   * @memberof TrashItem
   */
  itemId: number;
  /**
   * Item title at deletion.
   * @type {string}
   * @memberof TrashItem
   */
  title: string;
  /**
   * Original parent suite ID. Null for an item at the project root.
   * @type {number}
   * @memberof TrashItem
   */
  parentId?: number;
  /**
   * ID of the user who deleted the item, if the account still exists.
   * @type {number}
   * @memberof TrashItem
   */
  deletedBy?: number;
  /**
   * User display name saved at deletion, retained if the account is removed.
   * @type {string}
   * @memberof TrashItem
   */
  deletedByName?: string;
  /**
   * UTC deletion time in ISO 8601 format.
   * @type {string}
   * @memberof TrashItem
   */
  deletedAt: string;
  /**
   * UTC restore deadline, exactly 60 days after deletion. The daily job removes expired content permanently.
   * @type {string}
   * @memberof TrashItem
   */
  expiresAt: string;
}

export function TrashItemFromJSON(json: any): TrashItem {
  return {
    id: json["id"],
    project: json["project"],
    itemType: json["item_type"],
    itemId: json["item_id"],
    title: json["title"],
    parentId: !exists(json, "parent_id") ? undefined : json["parent_id"],
    deletedBy: !exists(json, "deleted_by") ? undefined : json["deleted_by"],
    deletedByName: !exists(json, "deleted_by_name")
      ? undefined
      : json["deleted_by_name"],
    deletedAt: json["deleted_at"],
    expiresAt: json["expires_at"],
  };
}

export function TrashItemToJSON(value?: TrashItem): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    project: value.project,
    item_type: value.itemType,
    item_id: value.itemId,
    title: value.title,
    parent_id: value.parentId,
    deleted_by: value.deletedBy,
    deleted_by_name: value.deletedByName,
    deleted_at: value.deletedAt,
    expires_at: value.expiresAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum TrashItemItemTypeEnum {
  TestCase = "test_case",
  Suite = "suite",
}
